/* eslint-disable no-dupe-keys */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { ClearableSearchField } from "components/SearchField/SearchField";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  Box,
  Card,
  Typography,
  Modal,
  CardContent,
  InputAdornment,
  Button,
  Autocomplete,
} from "@mui/material";
import { appConstants } from "utils/appConstants";
import MDButton from "components/MDButton";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import { CSVLink } from "react-csv";
import HelpIcon from "@mui/icons-material/Help";
import { getScreenRight } from "utils/generic";
import { fetchRCTIReportData } from "utils/api";
// import { getClientReport } from 'utils/superAdminApi';
import { useDispatch } from "react-redux";
import { BTable } from "components/BTable/BTable";
import PageTitle from "examples/PageTitle/PageTitle";
import { showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import { GridSearchIcon } from "@mui/x-data-grid";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import { useMaterialUIController } from "context";
import { fetchRCTIContacts } from "utils/api";
import { useSelector } from "react-redux";
import axios from "axios";
import PickDate from "components/DatePicker/DatePicker";
import TimelineItem from "components/Icon/TimelineItem";
import { formatCurrencyAUD } from "utils/formatCurrency";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  display: "grid",
  justifyContent: "center",
};
let SCREEN_RIGHT;
function RctiReport() {
  const [rows, setRows] = useState([]);
  const [showFilters, setShowFilters] = useState(false);
  const [tabledata, setTableData] = useState([]);
  const [showModel, setShowModel] = useState(false);
  const [resetClicked, setResetClicked] = useState(false);
  const [disableColor, setDisableColor] = useState(false);
  const dispatch = useDispatch();
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [customerReload, setCustomerReload] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [contact, setContact] = useState([]);
  const [screenAccess, setScreenAccess] = useState(false);

  // const [contactSupplierName, setContactSupplierName] = useState([]);

  const [values, setValues] = React.useState({
    rctiStatus: "",
    rctiDuration: "",
    supplierName: "",
    filterValues: "",
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    customFrom: new Date(new Date().setDate(new Date().getDate() - 1)),
    customTo: new Date(),
    searchParameterList: [
      "rctiDate",
      "rctiNumber",
      "supplierName",
      "purchaseOrderNumber",
      "supplyDate",
      "rctiStatus",
      "itemName",
      "itemID",
      "itemPrice",
      "itemQuantity",
      "discountType",
      "discountValue",
      "discountAmount",
      "gst",
      "gstType",
      "finalAmount",
      "totalAmount",
      "itemCategory",
      "totalDiscountAmount",
      "paymentInstruction",
      " rctiDateString",
      "individualItemAmount",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });
  //
  let currency = useSelector((state) => state.currency.currencySymbol);

  //
  const headers = [
    { label: "RCTI Number", key: "rctiNumber" },
    { label: "RCTI Date", key: "rctiDateToString" },
    { label: "Supplier Name", key: "supplierName" },
    { label: "Reference Number", key: "purchaseOrderNumber" },
    { label: "RCTI Status", key: "rctiStatus" },
    { label: "Supply Date", key: "supplyDate" },
    // { label: "Account", key: "itemCategory" },
    // { label: "Item Name", key: "itemName" },
    // { label: "Item Price", key: "itemPrice" },
    // { label: "Item Quantity", key: "itemQuantity" },
    // { label: "Discount Type", key: "discountType" },
    // { label: "Discount Amount", key: "discountAmount" },
    // { label: "GST(%)", key: "gst" },
    // { label: "GST Type", key: "gstType" },
    { label: "Final Amount", key: "finalAmount" },
    { label: "Total Amount", key: "totalAmount" },
    { label: "Total Discount Amount", key: "totalDiscountAmount" },
    { label: "PaymentInstruction", key: "paymentInstruction" },
    // { label: "Individual Amount", key: "individualItemAmount" },
  ];

  useEffect(() => {
    (async () => {
      await getRight();
      fetchRctiReport();
      fetchRCTIContact();
    })();
  }, [customerReload]);

  async function getRight() {
    let SCREEN_RIGHT = await getScreenRight("RCTI Reports");
    if (SCREEN_RIGHT === "Full Access") {
      setDisableColor(false);
      setScreenAccess(true);
    } else {
      setDisableColor(true);
    }
  }

  const fetchRctiReport = () => {
    let toDate = new Date(values.customTo);
    toDate.setUTCHours(0, 0, 0, 0);
    let fromDate = new Date(values.customFrom);
    fromDate.setUTCHours(0, 0, 0, 0);

    if (toDate < fromDate) {
      return showResMsg(
        "To Date should not be less than from date.",
        2000,
        false
      );
    }
    fetchRCTIReportData(
      values,
      (data) => {
        console.log("rctidata", data);
        setTotalRows(data.result.Result_Output.totalDocs);
        setRows(data.result.Result_Output.docs);
        setTableData(data.result.export);
      },
      dispatch
    );
  };

  const handleChange = (name) => (event) => {
    setValues({ ...values, [name]: event.target.value });
  };

  const handleContactChange = (name) => (event, newValue) => {
    if (newValue) {
      setValues({
        ...values,
        [name]: newValue.label,
        contactTypeId: newValue.value,
      });
    } else {
      setValues({ ...values, [name]: "", contactTypeId: "" });
    }
  };

  const FilterData = async () => {
    fetchRctiReport();
  };

  const ResetData = () => {
    setValues((prevValues) => ({
      ...prevValues,
      searchParameter: "",
      page: appConstants.page,
      limit: appConstants.limit,
      sortingType: "",
      sortingField: "",
      rctiStatus: "",
      rctiDuration: "",
      supplierName: "",
      filterValues: "",
      searchParameterList: [
        "rctiDate",
        "rctiNumber",
        "supplierName",
        "purchaseOrderNumber",
        "supplyDate",
        "rctiStatus",
        "itemName",
        "itemID",
        "itemPrice",
        "itemQuantity",
        "discountType",
        "discountValue",
        "discountAmount",
        "gst",
        "gstType",
        "finalAmount",
        "totalAmount",
        "itemCategory",
        "totalDiscountAmount",
        "paymentInstruction",
        " rctiDateString",
        "individualItemAmount",
      ],
    }));
    setResetClicked(true);
  };

  useEffect(() => {
    if (resetClicked) {
      fetchRctiReport();
      setResetClicked(false);
    }
  }, [resetClicked]);

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    setCustomerReload(!customerReload);
  };
  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
    setCustomerReload(!customerReload);
  };
  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
    setCustomerReload(!customerReload);
  };

  function exportSwal() {
    setShowModel(false);
    showResMsg(genericMessage.dataExportedSucces, 1000, true);
  }

  const fetchRCTIContact = async () => {
    await fetchRCTIContacts(
      values,
      (data) => {
        setContact(data.Result_Output);
      },
      dispatch
    );
  };

  const handleDateChange = (name) => (date) => {
    setValues({ ...values, [name]: new Date(date) });
  };

  // Give theme color to hide filter --- Starts here

  const { tableBorder } = getColorMappings(sidenavColor);
  // var element = document.getElementsByTagName('fieldset');
  // useEffect(() => {
  //   for (let i = 0; i < element.length; i++) {

  //     if (darkMode) {
  //       element[i].style.borderColor = "white";
  //     } else {
  //       element[i].style.borderColor = tableBorder;
  //     }

  //   }
  // }, [showFilters])

  useEffect(() => {
    var element = document.getElementsByTagName("fieldset");
    let labelShrink = document.getElementsByClassName("MuiInputLabel-outlined");
    for (let i = 0; i < element.length; i++) {
      element[i].style.borderColor = darkMode ? "white" : tableBorder;
    }

    for (let i = 0; i < labelShrink.length; i++) {
      labelShrink[i].style.color = darkMode ? "white" : tableBorder;
    }
  }, [showFilters]);

  useEffect(() => {
    var dropicons = document.querySelectorAll(".MuiInputBase-root");
    for (let i = 0; i < dropicons.length; i++) {
      var svgicon = dropicons[i].getElementsByTagName("svg");
      if (svgicon.length > 0) {
        if (darkMode) {
          svgicon[0].setAttribute("style", "fill: white !important;");
        } else {
          svgicon[0].setAttribute("style", "");
        }
      }
    }
  }, [showFilters]);

  const reportCol = [
    {
      // name: "RCTI Number",
      name: <p style={{ fontSize: "12px" }}>RCTI Number</p>,
      selector: (row) => row.rctiNumber,
      sortable: true,
      sortField: "rctiNumber",
      style: { textAlign: "left" },
      minWidth: "140px",
    },
    {
      // name: "RCTI Date",
      name: <p style={{ fontSize: "12px", paddingLeft: "22px" }}>RCTI Date</p>,
      selector: (row) => row.rctiDateToString,
      sortable: true,
      sortField: "rctiDateToString",
      // style: { textAlign: 'left', paddingLeft: '10px' },
      center: true,
      minWidth: "160px",
    },
    {
      // name: "Customer Name",
      name: (
        <p style={{ fontSize: "12px", paddingLeft: "22px" }}>Supplier Name</p>
      ),
      selector: (row) => row.supplierName,
      sortable: true,
      sortField: "supplierName",
      center: true,
      minWidth: "160px",
    },
    {
      // name: "Purchase Order Number",
      name: (
        <p style={{ fontSize: "12px", paddingLeft: "22px" }}>
          Reference Number
        </p>
      ),
      selector: (row) => row.purchaseOrderNumber,
      sortable: true,
      center: true,
      sortField: "purchaseOrderNumber",
      center: true,
      minWidth: "180px",
    },
    {
      // name: "RCTI Status",
      name: (
        <p style={{ fontSize: "12px", paddingLeft: "22px" }}>RCTI Status</p>
      ),
      selector: (row) => row.rctiStatus,
      sortable: true,
      sortField: "rctiStatus",
      center: true,
      minWidth: "140px",
      cell: (row) => (
        <span
          style={{
            border: "1px solid black",
            color: "black",
            padding: "3px 3px",
            borderRadius: "2px",
            fontSize: "12px",
            fontWeight: 500,
            textTransform: "capitalize",
            display: "inline-block",
            minWidth: "60px",
            textAlign: "center",
          }}
        >
          {row.rctiStatus || "N/A"}
        </span>
      ),
    },
    {
      // name: "Supply Date",
      name: <p style={{ fontSize: "12px", paddingLeft: "22px" }}>Supply Date</p>,
      selector: (row) => row.supplyDate,
      sortable: true,
      sortField: "supplyDate",
      center: true,
      minWidth: "140px",
    },
    // {
    //   // name: "Category",
    //   name: <p style={{ fontSize: "12px" }}>Account</p>,
    //   selector: row => row.itemCategory,
    //   sortable: true,
    //   sortField: 'itemCategory',
    //   minWidth: '140px'
    // },
    // {
    //   // name: "Item Name",
    //   name: <p style={{ fontSize: '12px' }}>Item Name</p>,
    //   selector: row => row.itemName,
    //   sortable: true,
    //   sortField: 'itemName',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   // name: "Item Price",
    //   name: <p style={{ fontSize: "12px" }}>{`Item Price  (${currency})`}</p>,
    //   selector: row => row.itemPrice,
    //   sortable: true,
    //   sortField: 'itemPrice',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   // name: "Item Quantity",
    //   name: <p style={{ fontSize: "12px" }}>Item Quantity</p>,
    //   selector: row => row.itemQuantity,
    //   sortable: true,
    //   sortField: 'itemQuantity',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: "Discount Type",
    //   name: <p style={{ fontSize: "12px" }}>Discount Type</p>,
    //   selector: row => row.discountType,
    //   sortable: true,
    //   sortField: 'discountType',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   name: "Discount Amount",
    //   name: <p style={{ fontSize: "12px" }}> {`Discount Amount  (${currency})`}</p>,
    //   selector: row => row.discountAmount,
    //   sortable: true,
    //   sortField: 'discountAmount',
    //   center: true,
    //   minWidth: '160px'
    // },
    // {
    //   // name: "GST",
    //   name: <p style={{ fontSize: "12px" }}>GST(%)</p>,
    //   selector: row => row.gst,
    //   sortable: true,
    //   sortField: 'gst',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   // name: "GST Type",
    //   name: <p style={{ fontSize: "12px" }}>GST Type</p>,
    //   selector: row => row.gstType,
    //   sortable: true,
    //   sortField: 'gstType',
    //   center: true,
    //   minWidth: '140px'
    // },
    // {
    //   // name: "Individual Amount",
    //   name: <p style={{ fontSize: '12px' }}>{`Individual Amount  (${currency})`}</p>,
    //   selector: row => row.individualItemAmount,
    //   sortable: true,
    //   sortField: 'individualItemAmount',
    //   center: true,
    //   minWidth: '160px'
    // },
    {
      // name: "Final Amount",
      name: (
        <p
          style={{ fontSize: "12px", paddingLeft: "30px" }}
        >{`Final Amount  (${currency})`}</p>
      ),
      selector: (row) => formatCurrencyAUD(row.finalAmount),
      sortable: true,
      sortField: "finalAmount",
      center: true,
      minWidth: "180px",
    },
    {
      // name: "Total Amount ",
      name: (
        <p
          style={{ fontSize: "12px", paddingLeft: "30px" }}
        >{`Total Amount  (${currency})`}</p>
      ),
      selector: (row) => formatCurrencyAUD(row.totalAmount),
      sortable: true,
      sortField: "totalAmount",
      center: true,
      minWidth: "180px",
    },
    {
      // name: "Total Discount Amount",
      name: (
        <p
          style={{ fontSize: "12px", paddingLeft: "30px" }}
        >{`Total Discount Amount  (${currency})`}</p>
      ),
      selector: (row) => formatCurrencyAUD(row.totalDiscountAmount),
      sortable: true,
      sortField: "totalDiscountAmount",
      center: true,
      minWidth: "230px",
    },
    {
      // name: "PaymentInstruction",
      name: (
        <p style={{ fontSize: "12px", paddingLeft: "22px" }}>
          Payment Instruction
        </p>
      ),
      selector: (row) => row.paymentInstruction,
      sortable: true,
      sortField: "paymentInstruction",
      center: true,
      minWidth: "190px",
    },
    {
      name: "Actions",
      selector: (row) => row._id,
      center: true,
      cell: (row) => (
        <>
          <Grid
            container
            justifyContent={"center"}
            mr={2}
            spacing={4}
            mt={-6.2}
          >
            <Grid item>
              <Link
                to={`/report/item/${row._id}`}
                onClick={() =>
                  sessionStorage.setItem("reportType", "RctiItems")
                } // 👈 store value
              >
                <TimelineItem color="success" icon="visibility" title="view" />
              </Link>
            </Grid>
          </Grid>
        </>
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="RCTI Report" />
          <Grid
            container
            columnSpacing={2}
            px={2}
            mt={2}
            mb={1}
            alignItems="center"
            display="flex"
            justifyContent="right"
          >
            {showFilters && (
              <Grid item xs={12} md={6} lg={9.2}>
                {values.rctiDuration === "Custom" && (
                  <Grid
                    container
                    spacing={1.6}
                    sx={{
                      display: "flex",
                      justifyContent: "start",
                      paddingLeft: "10px",
                    }}
                  >
                    <Grid item xs={6} lg={1.7}>
                      <PickDate
                        selected={new Date(values.customFrom)}
                        onChange={handleDateChange("customFrom")}
                        label="From"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        maxDate={
                          new Date(new Date().setDate(new Date().getDate() - 1))
                        }
                      />
                    </Grid>
                    <Grid item xs={6} lg={1.7}>
                      <PickDate
                        selected={new Date(values.customTo)}
                        onChange={handleDateChange("customTo")}
                        label="To"
                        variant="outlined"
                        InputLabelProps={{ shrink: true }}
                        maxDate={new Date()}
                      />
                    </Grid>
                  </Grid>
                )}
              </Grid>
            )}
            <Grid item xs={12} md={4} spacing={2} lg={1.4} gap={0.5}>
              <MDButton
                className={
                  "btn-block center-container-btn btn-warning btn-back rightSpace"
                }
                color={"warning"}
                fullWidth
                onClick={() => {
                  setShowFilters(!showFilters);
                }}
                style={{ height: "38.11px" }}
              >
                {showFilters ? "Hide Filters" : "Set Filters"}
              </MDButton>
            </Grid>
            <Grid item xs={12} md={4} spacing={2} lg={1.4}>
              {screenAccess ? (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  style={{
                    backgroundColor: "#009cff",
                    color: "#ffffff",
                    height: "38.11px",
                  }}
                  fullWidth
                  onClick={() => {
                    setShowModel(true);
                  }}
                >
                  Export
                </MDButton>
              ) : (
                <MDButton
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  style={{ height: "38.11px" }}
                  color={"secondary"}
                  fullWidth
                >
                  Export
                </MDButton>
              )}
            </Grid>
          </Grid>
          {showFilters && (
            <MDBox>
              <Grid item xs={12}>
                <MDBox px={1} pt={1}>
                  <Grid container columnSpacing={2} mx={0.1}>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="invoiceDate">
                            RCTI Duration
                          </InputLabel>
                          <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            style={{ height: "38.11px" }}
                            label="RCTI Duration"
                            value={values.rctiDuration}
                            onChange={handleChange("rctiDuration")}
                          >
                            {/* <MenuItem value="All"> All </MenuItem> */}
                            <MenuItem value="Today"> Today </MenuItem>
                            <MenuItem value="last7Days"> Last 7 Days </MenuItem>
                            <MenuItem value="last30Days">
                              {" "}
                              Last 30 Days{" "}
                            </MenuItem>
                            <MenuItem value="last1Year">
                              {" "}
                              Last 12 Month{" "}
                            </MenuItem>
                            <MenuItem value="Custom"> Custom Date</MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>
                    <Grid item xs={12} lg={2.3}>
                      <MDBox mb={4} xs={12}>
                        <FormControl fullWidth>
                          <InputLabel id="rctiStatus">RCTI Status</InputLabel>
                          <Select
                            labelId="rctiStatus-select-label"
                            id="rctiStatus-select"
                            style={{ height: "38.11px" }}
                            label="Invoice Status"
                            value={values.rctiStatus}
                            onChange={(e) =>
                              setValues({
                                ...values,
                                rctiStatus: e.target.value,
                              })
                            }
                          >
                            {/* <MenuItem value="All">All</MenuItem> */}
                            <MenuItem value="Paid">Paid</MenuItem>
                            <MenuItem value="Unpaid">Unpaid</MenuItem>
                            <MenuItem value="Partial Paid">
                              Partial Paid
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </MDBox>
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <Autocomplete
                        labelId="contactName-select-label"
                        id="contactName-select"
                        options={contact.map((contact) => ({
                          label: contact.supplierName,
                          value: contact._id,
                        }))}
                        onChange={handleContactChange("supplierName")}
                        value={values.supplierName}
                        sx={{
                          "& .MuiAutocomplete-inputRoot": {
                            height: "38.11px",
                          },
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Supplier Name"
                            placeholder="Supplier Name"
                            className="ress"
                          />
                        )}
                      />
                    </Grid>

                    <Grid item xs={12} lg={2.3}>
                      <ClearableSearchField
                        type="text"
                        label="Search"
                        variant="outlined"
                        fullWidth
                        className="searchButton"
                        placeholder="Search..."
                        size="medium"
                        autoComplete="digital"
                        value={values.filterValues}
                        onChange={handleSearchFilter}
                        onKeyUp={(e) => {
                          if (e.key === "Enter") fetchRctiReport();
                        }}
                        InputProps={{
                          endAdornment: (
                            <InputAdornment>
                              <Button
                                style={{
                                  borderRadius: "3px 0.3rem  0.3rem 0px",
                                  background: barColor,
                                }}
                                variant="contained"
                                onClick={fetchRctiReport}
                              >
                                <GridSearchIcon color="white" />
                              </Button>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>

                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <Link to={"/RctiReport"}>
                        <MDButton
                          className="btn-block center-container-btn btn-warning btn-back rightSpace"
                          color="warning"
                          fullWidth
                          onClick={ResetData}
                          style={{ height: "38.11px" }}
                        >
                          Reset
                        </MDButton>
                      </Link>
                    </Grid>
                    <Grid item xs={12} md={2} spacing={1} lg={1.2}>
                      <MDButton
                        rel="noreferrer"
                        variant="gradient"
                        color="success"
                        fullWidth
                        onClick={FilterData}
                        style={{ height: "38.11px" }}
                      >
                        Apply
                      </MDButton>
                    </Grid>
                  </Grid>
                </MDBox>
              </Grid>
            </MDBox>
          )}
          {/* <CardContent> */}
          <BTable
            columns={reportCol}
            data={rows}
            selectableRows={false}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            // fixedHeaderScrollHeight="410px"
            // fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
        {showModel && (
          <Modal
            open={showModel}
            onClose={() => setShowModel(false)}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Card sx={style}>
              <Box>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ fontSize: "40px", textAlign: "center" }}
                >
                  <HelpIcon style={{ color: "red" }} />
                </Typography>
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  style={{ color: "black" }}
                >
                  Would you like to export this record?
                </Typography>
                <Grid
                  container
                  id="modal-modal-description"
                  sx={{ mt: 2, justifyContent: "center" }}
                >
                  <>
                    <MDButton
                      className="no-button"
                      onClick={() => {
                        setShowModel(false);
                      }}
                      sx={{ width: "64px", textTransform: "capitalize" }}
                    >
                      No
                    </MDButton>
                  </>
                  &nbsp; &nbsp;
                  <>
                    <CSVLink
                      data={tabledata}
                      headers={headers}
                      filename={
                        "RCTI Report (" +
                        new Date().toLocaleDateString("en-US", {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                        }) +
                        ") .csv"
                      }
                    >
                      <MDButton
                        className="yes-button"
                        onClick={() => {
                          exportSwal();
                        }}
                        sx={{ width: "64px", textTransform: "capitalize" }}
                      >
                        Yes
                      </MDButton>
                    </CSVLink>
                  </>
                </Grid>
              </Box>
            </Card>
          </Modal>
        )}
      </div>
    </DashboardLayout>
  );
}
export default RctiReport;
